import { Injectable } from '@angular/core';
import { firstValueFrom, fromEvent, merge } from 'rxjs';
import { filter, map, startWith, take, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AppEvents } from './app.events';

@Injectable({
  providedIn: 'root'
})
export class NetworkService {

  private checking = false;

  online = false;

  constructor(
    private appEvents: AppEvents
  ) { }

  async init() {
    merge(
      fromEvent(window, 'online').pipe(map(x => true)),
      fromEvent(window, 'offline').pipe(
        map(x => false),
        tap(x => this.setOnline(false))
      )
    ).pipe(
      startWith(true),
      tap(x => {
        if (x)
          this.startChecking()
      })
    ).subscribe();

    await firstValueFrom(this.appEvents.online$.pipe(filter(x => x), take(1)));
  }

  async startChecking() {
    const callback = async () => {
      if (navigator.onLine == false) {
        this.setOnline(false);
        return;
      }

      const online = await this.check();
      if (online === false)
        setTimeout(callback, 5000);
    };
    callback();
  }

  async check() {
    if (this.checking) return;
    try {
      this.checking = true;
      const rsp = await fetch(`${environment.baseUrl}/api/v1/ping`, { method: 'GET' });
      if (!rsp.ok) {
        this.setOnline(false);
      } else {
        const rspBody = await rsp.json();
        this.setOnline(rspBody.success === true);
      }
    } catch (err) {
      this.setOnline(false);
    }
    this.checking = false;
    return this.online;
  }

  private setOnline(online: boolean) {
    console.log('setOnline %o, %o', this.online, online);
    if (this.online == online)
      return;

    this.online = online;
    this.appEvents.online$.next(online);
  }
}
